import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';

import BACKEND_URL from '../../../api';

const ChartFive = ({ year }) => {
  const userid = sessionStorage.getItem('userid')
  const thisYear = new Date().getFullYear();

  const [state, setState] = useState({
    series: [
      {
        name: 'Result',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      }
    ],
  });
  const [options, setOptions] = useState({
    legend: {
      show: true,
      position: 'top',
      horizontalAlign: 'left',
    },
    colors: ['#3C50E0', '#80CAEE'],
    title: {
        text: "Domestic Billing",
        align: "center",
    },
    chart: {
      fontFamily: 'Satoshi, sans-serif',
      height: 335,
      type: 'area',
      dropShadow: {
        enabled: true,
        color: '#623CEA14',
        top: 10,
        blur: 4,
        left: 0,
        opacity: 0.1,
      },

      toolbar: {
        show: false,
      },
    },
    responsive: [
      {
        breakpoint: 1024,
        options: {
          chart: {
            height: 300,
          },
        },
      },
      {
        breakpoint: 1366,
        options: {
          chart: {
            height: 350,
          },
        },
      },
    ],
    stroke: {
      width: [2, 2],
      curve: 'straight',
    },
    grid: {
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 4,
      colors: '#fff',
      strokeColors: ['#3056D3'],
      strokeWidth: 3,
      strokeOpacity: 0.9,
      strokeDashArray: 0,
      fillOpacity: 1,
      discrete: [],
      hover: {
        size: undefined,
        sizeOffset: 5,
      },
    },
    xaxis: {
      type: 'category',
      categories: [
        '0.5 KG',
        '0.6-2.5 KG',
        '2.6-5 KG',
        '5.1-10 KG',
      ],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      title: {
        style: {
          fontSize: '0px',
        },
      },
    },
  })

  useEffect(() => {
    axios.post(`${BACKEND_URL}/getDomestic`, {
      thisYear: year,
      userid: userid
    }, {})
      .then((res) => {
        console.log("getDomestic------------", res.data)

        const newState = {
          ...state,
          series: [
            { ...state.series[0], data: res.data.result }
          ]
        };

        setState(newState);
      })
      .catch((err) => console.log(err))
  }, [year])

  return (
    <div style={{ margin: "20px 10px 20px 20px", borderRadius: "12px", border: "1px solid #E5E7EB", backgroundColor: "white", paddingTop: "10px" }}>
      <div>
        <div id="chartOne" className="-ml-5">
          <ReactApexChart
            options={options}
            series={state.series}
            type="bar"
            height={350}
          />
        </div>
      </div>
    </div>
  );
};

export default ChartFive;
